module.exports = __webpack_public_path__ + "img/dic_local_point_v3.b08ab057.png";